import Vue from "vue";
import App from "./App.vue";
// import vuetify from "./plugins/vuetify";
import VueSweetalert2 from "vue-sweetalert2";
import moment from "moment";
// import cognitoAuth from "./cognito";
// import Amplify, { Auth } from "aws-amplify";
// import cognitoConfig from "./amplifyCognito/index";
import router from "./router";
import store from "./store";
import { domain, clientId } from "../auth_config.json";
import { Auth0Plugin } from "./auth";
import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";
import "sweetalert2/dist/sweetalert2.min.css";
import VueApexCharts from "vue-apexcharts";
import "./quasar";
import * as VueGoogleMaps from "vue2-google-maps";
import "./registerServiceWorker";
import "vue-json-pretty/lib/styles.css";

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

Vue.config.productionTip = false;

localStorage.setItem("currentUser", JSON.stringify({}));
localStorage.setItem("currentUserData", JSON.stringify({}));

Vue.directive("clickable", {
  inserted: function (el) {
    el.style.cursor = "pointer";
  }
});

Vue.prototype.$moment = moment;

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

Vue.use(VueSweetalert2);

// Vue.use(VueQrcodeReader);
Vue.use(Croppa);

Vue.use(moment);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyA4Z1gufJy4sBnc8RCLq1lT9Edc1pbd06w",
    libraries: "places" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

// Vue.use(ApexCharts);

// Vue.use(TiptapVuetifyPlugin, {
//   // the next line is important! You need to provide the Vuetify Object to this place.
//   vuetify, // same as "vuetify: vuetify"
//   // optional, default to 'md' (default vuetify icons before v2.0.0)
//   iconsGroup: "mdi"
// });

Vue.filter("momentFromNow", function (value) {
  return moment
    .utc(value)
    .local()
    .fromNow();
});

Vue.filter("momentFormat", function (value) {
  return moment
    .utc(value)
    .local()
    .format("MMMM Do YYYY, h:mm:ss a");
});

Vue.filter("momentFormatDMY", function (value) {
  return value
    ? moment
      .utc(value)
      .local()
      .format("DD-MMM, YYYY")
    : "";
});

Vue.filter("momentFormatDMYRaw", function (value) {
  return value ? moment(value).format("DD-MMM, YYYY") : "";
});

Vue.filter("numberFormat", function (value) {
  return new Intl.NumberFormat().format(value);
});

Vue.filter("percentFromPrevious", function (value) {
  (100 * partialValue) / totalValue;
  return new Intl.NumberFormat().format(value);
});

Vue.filter("findFirstFilledLane", function (numLanes, numParticipants) {
  const numEmptyLanes = numLanes - numParticipants;
  const firstFilledLane = Math.ceil(numEmptyLanes / 2) + 1;
  return firstFilledLane;
});

Vue.filter("shuffle", function (array) {
  // Fisher-Yates shuffle
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    let k = array[i];
    array[i] = array[j];
    array[j] = k;
  }
  return array;
});

Vue.mixin({
  methods: {
    percentFromPrevious(partialValue, totalValue) {
      let percent = (100 * partialValue) / totalValue;
      return (percent - 100).toFixed(1);
    },
    momentFormat(value, utcFormat = true, format = "MMMM Do YYYY, h:mm:ss a") {
      return utcFormat
        ? moment
          .utc(value)
          .local()
          .format(format)
        : moment(value).format(format);
    },
    moneyFormatter(money) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
      });
      return formatter.format(parseFloat(money));
    }
  }
});

new Vue({
  router,
  store,
  head: {
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"
      }
    ]
  },
  beforeCreate() {
    this.$store.dispatch("settings/setFullLoaderState", true);

    this.$store.dispatch("auth/initAuth");
    this.$store.dispatch("settings/checkOnlineStatus");
    this.$store.dispatch("settings/loadDefaultDateRange");
    this.$store.dispatch("settings/updateValues");
    setInterval(() => {
      this.$store.dispatch("auth/initAuth");
    }, 300000);

    // this.$store.dispatch("setFullLoaderState", true);
    // this.$store.dispatch("loadSiteData").then(() => {
    //     this.$store.dispatch("initAuth");
    // });
  },
  render: h => h(App)
}).$mount("#app");
